import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { PageHero } from "./About";
import EuropeMap from "../components/EuropeMap";
import { SectionHeader, PillLabel } from "../components/UI";

export default function Markets() {
  const { t } = useTranslation();
  const [tip, setTip] = useState(null);
  const activeKeys = ["italy","germany","switzerland","netherlands","belgium","luxembourg","baltics"];
  const sidebarKeys = ["italy","germany","switzerland","netherlands","baltics"];
  const futureKeys = ["uk","portugal","greece","austria","poland","nordics","czech","hungary","romania","croatia"];

  const onEnter = (id, e) => setTip({ id, x: e.clientX, y: e.clientY });
  const onMove = (e) => setTip(prev => prev ? {...prev, x:e.clientX, y:e.clientY} : prev);
  const onLeave = () => setTip(null);
  const country = tip && (activeKeys.includes(tip.id) || futureKeys.includes(tip.id)) ? t(`markets.countries.${tip.id}`, { returnObjects: true }) : null;
  const isActive = tip && activeKeys.includes(tip.id);

  return (
    <div data-testid="page-markets">
      <PageHero eyebrow="Covered Markets" title={t("markets_page.hero_title")} subtitle={t("markets_page.hero_subtitle")} image="https://images.unsplash.com/photo-1581091212911-f4efc3f71c48"/>
      <section className="py-24 md:py-32 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-8 bg-[#F5F7FB] p-8 rounded-sm border border-slate-200">
            <EuropeMap onCountryEnter={onEnter} onCountryLeave={onLeave} onCountryMove={onMove}/>
          </div>
          <div className="lg:col-span-4 space-y-6">
            <div>
              <div className="eyebrow">{t("markets_page.coverage_title")}</div>
              <h3 className="mt-3 font-display font-semibold text-2xl">Founding markets</h3>
              <ul className="mt-4 divide-y divide-slate-200 border border-slate-200 rounded-sm">
                {sidebarKeys.map(k => (
                  <li key={k} className="flex items-center justify-between px-4 py-3">
                    <span className="font-display text-sm text-[#0B1120]">{t(`markets.countries.${k}.name`)}</span>
                    <PillLabel tone="primary">{t("markets.status_operational")}</PillLabel>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h3 className="font-display font-semibold text-2xl">Expansion roadmap</h3>
              <ul className="mt-4 divide-y divide-slate-200 border border-slate-200 rounded-sm">
                {futureKeys.map(k => (
                  <li key={k} className="flex items-center justify-between px-4 py-3">
                    <span className="font-display text-sm text-[#0B1120]">{t(`markets.countries.${k}.name`)}</span>
                    <PillLabel tone="muted">{t(`markets.countries.${k}.note`)}</PillLabel>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>
      {tip && country && (
        <div className="fixed pointer-events-none z-40" style={{ left: tip.x + 14, top: tip.y + 14 }}>
          <div className="bg-white border border-slate-200 shadow-2xl px-4 py-3 min-w-[220px] rounded-sm">
            <div className="font-display font-semibold text-[#003399] text-sm mb-2">{country.name}</div>
            <div className="text-[10px] tracking-[0.2em] uppercase text-slate-500 mb-1">{t("markets.tooltip_partner")}</div>
            <div className="text-xs text-[#0B1120] mb-2">{country.partner}</div>
            <div className="text-[10px] tracking-[0.2em] uppercase text-slate-500 mb-1">{t("markets.tooltip_dealers")}</div>
            <div className="text-xs text-[#0B1120] mb-2">{country.dealers}</div>
            <div className="text-[10px] tracking-[0.2em] uppercase text-slate-500 mb-1">{t("markets.tooltip_status")}</div>
            <div className={`text-xs font-medium ${isActive ? 'text-[#003399]' : 'text-slate-500'}`}>{isActive ? t("markets.status_operational") : t("markets.status_expansion")} · {country.note}</div>
          </div>
        </div>
      )}
    </div>
  );
}
